import React, { useEffect, useState } from 'react';
import { JiraSprintLiteData } from '../../../api/endpoints/jira';
import { CommandFlowActionCallback } from '../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { useResolve } from '../../Container';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { JiraSprintInput } from '../../external/atlassian/inputs/JiraSprintInput';
import { jiraSprintImport } from './JiraSprintCommands';

export const JiraSprintImportFlow = React.memo(({ onAction }: { onAction: CommandFlowActionCallback }) => {

    const dispatch = useResolve(CommandDispatcher);
    const [sprint, setSprint] = useState<JiraSprintLiteData | null>(null);

    useEffect(() => {
        if (sprint) {
            dispatch(jiraSprintImport, { jiraSprintId: sprint.id });
            onAction('complete');
        }
    }, [sprint, onAction]);

    return <Flexer>
        <JiraSprintInput
            autoFocus
            field={{ name: 'Sprint', required: true, hasDefaultValue: false }}
            value={sprint}
            onChange={setSprint}
            onSubmit={setSprint}
        />
    </Flexer>;
});
